export let ENV = 'development1'
export const API_BASE_URL = ''
export const SPORT_TYPES_HEIGHT = 61
export const SUB_SPORT_TYPES_HEIGHT = 52
export const LIVE_GAME_HEIGHT = 61
export const CHAMPIONSHIP_HEAD_HEIGHT = 34
export const SECTION_HEIGHT = 48
export const TOP_BAR_HEIGHT = 50
export const SPORT_DATA_UPDATE_INTERVAL = 10000
export const DEFAULT_SPORT_TYPE = '16'
export const DEFAULT_SUB_SPORT_TYPE = null
export const ADDITIONAL_RESULTS_SPORTTYPE = 22
export const FAVORITES_SPORTTYPE = -666
export const TOP_LEAGUES_SPORTTYPE = -1
export const SHOW_SPORT_ICON_SPORT_TYPES = [
    String(TOP_LEAGUES_SPORTTYPE),
    String(FAVORITES_SPORTTYPE),
]
export const DEFAULT_COLLAPSED_SECTIONS = { current: true, today: false }
export const SHOW_SPORTS_COUNT_TYPES = [FAVORITES_SPORTTYPE]
export const RESULTS_WITH_THREE_ODDS_TYPES = [16, 24, 17, 18]
